import { Helpers } from '../../helpers';
import { IProject } from '../../interfaces/iproject';
import { Area } from '../area';
import { AssetTeam } from '../asset-team';
import { BudgetCategory } from '../budget-category';
import { BusinessAssociate } from '../business-associate';
import { CapitalOperationalExpenditure } from '../capital-operational-expenditure';
import { ConstructionType } from '../construction-type';
import { DefaultProjectTeam } from '../default-project-team';
import { Division } from '../division';
import { Employee } from '../employee';
import { ExploreDevelop } from '../explore-develop';
import { Function } from '../function';
import { OperatingUnit } from '../operating-unit';
import { ProjectAssetMapping } from '../project-asset-mapping';
import { ProjectCashCurve } from '../project-cash-curve';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ProjectCostCenter } from '../project-cost-center';
import { ProjectCostCodeCostTypeItem } from '../project-cost-code-cost-type-item';
import { ProjectCostCodeCostTypeItemsRevision } from '../project-cost-code-cost-type-items-revision';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { ProjectEstimate } from '../project-estimate';
import { ProjectEstimateAtCompletion } from '../project-estimate-at-completion';
import { ProjectItemCapacityOverride } from '../project-item-capacity-override';
import { ProjectModuleGasLiftLine } from '../project-module-gas-lift-line';
import { ProjectModulePipeline } from '../project-module-pipeline';
import { ProjectModuleWellConnectSurfaceEquipment } from '../project-module-well-connect-surface-equipment';
import { ProjectPondParameter } from '../project-pond-parameter';
import { ProjectResourceCalculationsAssignment } from '../project-resource-calculations-assignment';
import { ProjectResourceItem } from '../project-resource-item';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';
import { ProjectStatus } from '../project-status';
import { ProjectSubType } from '../project-sub-type';
import { ProjectTeamMemberAssignment } from '../project-team-member-assignment';
import { ProjectType } from '../project-type';
import { ResourceAssignment } from '../resource-assignment';
import { Scenario } from '../scenario';
import { Schedule } from '../schedule';

export class ProjectBase {
  ProjectId: number;
  AfeNumber: string | null;
  AssetTeamId: number | null;
  IsBudgeted: boolean | null;
  BudgetYear: number | null;
  CapitalOperationalExpendatureId: number | null;
  ConstructionTypeId: number | null;
  TeamDevelopmentAreaId: number | null;
  DivisionId: number | null;
  ExploreDevelopId: number | null;
  FunctionId: number | null;
  NeedByDate: Date | null;
  IsNeedByDateSync: boolean | null;
  IsNeedByDateOverride: boolean | null;
  IsNonOperating: boolean | null;
  BusinessAssociateId: number | null;
  ProjectDescription: string | null;
  Name: string | null;
  ProjectStatusId: number | null;
  ProjectTeamId: number | null;
  IsProjectTeamSync: boolean | null;
  ProjectTypeId: number | null;
  IsResearchAndDevelopmentTaxIdentifier: boolean | null;
  IsEsg: boolean | null;
  EsgCategoryId: number | null;
  EsgAmount: number | null;
  EsgJustification: string | null;
  StartDate: Date | null;
  DefaultStandardConfigurationId: number | null;
  IsStandardConfigurationSync: boolean | null;
  WorkingInterest: number | null;
  IsScheduleSync: boolean | null;
  IsResearchAndDevelopmentBookIdentifier: boolean | null;
  ResearchAndDevelopmentTaxJustification: string | null;
  ResearchAndDevelopmentBookJustification: string | null;
  AfeApprovalDate: Date | null;
  IsExcludedFromAnnualBudget: boolean | null;
  DefaultProjectTeamId: number | null;
  PDFUrl: string | null;
  CreatePDF: boolean | null;
  ScheduleId: number | null;
  ScenarioId: number | null;
  PMDBProjectId: string | null;
  P6ProjectObjectId: number | null;
  CreatorUserId: number | null;
  Comments: string | null;
  IsPlanningAFE: boolean | null;
  ExpansionCount: number | null;
  ProjectSubTypeId: number | null;
  Prospect: string | null;
  OperatingUnitId: number | null;
  EPSP6ObjectId: number | null;
  P6EPSObjectId: number | null;
  Location: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SysStartTime: Date;
  SysEndTime: Date;
  P6SummaryActualFinishDate: Date | null;
  ReceivedByP6: Date | null;
  P6ProjectId: number | null;
  ProjectEconomics: string | null;
  BudgetCategoryId: number | null;
  AfeApprovalTeam: string | null;
  BatteryDesignTypeId: number | null;
  ProjectAssetMappings_Project?: Array<ProjectAssetMapping> | null;
  ProjectCashCurves_Project?: Array<ProjectCashCurve> | null;
  ProjectCompletionsParameters_Project?: Array<ProjectCompletionsParameter> | null;
  ProjectCostCenters_Project?: Array<ProjectCostCenter> | null;
  ProjectCostCodeCostTypeItems_Project?: Array<ProjectCostCodeCostTypeItem> | null;
  ProjectCostCodeCostTypeItemsRevisions_Project?: Array<ProjectCostCodeCostTypeItemsRevision> | null;
  ProjectDrillingParameters_Project?: Array<ProjectDrillingParameter> | null;
  ProjectEstimateAtCompletions_Project?: Array<ProjectEstimateAtCompletion> | null;
  ProjectEstimates_Project?: Array<ProjectEstimate> | null;
  ProjectItemCapacityOverrides_Project?: Array<ProjectItemCapacityOverride> | null;
  ProjectModuleGasLiftLines_Project?: Array<ProjectModuleGasLiftLine> | null;
  ProjectModulePipelines_Project?: Array<ProjectModulePipeline> | null;
  ProjectModuleWellConnectSurfaceEquipments_Project?: Array<ProjectModuleWellConnectSurfaceEquipment> | null;
  ProjectPondParameters_Project?: Array<ProjectPondParameter> | null;
  ProjectResourceCalculationsAssignments_Project?: Array<ProjectResourceCalculationsAssignment> | null;
  ProjectResourceItems_Project?: Array<ProjectResourceItem> | null;
  ProjectResourceItemsRevisions_Project?: Array<ProjectResourceItemsRevision> | null;
  ProjectTeamMemberAssignments_Project?: Array<ProjectTeamMemberAssignment> | null;
  ResourceAssignments_Project?: Array<ResourceAssignment> | null;
  AssetTeam?: AssetTeam;
  BudgetCategory?: BudgetCategory;
  BusinessAssociate?: BusinessAssociate;
  ConstructionType?: ConstructionType;
  DefaultProjectTeam?: DefaultProjectTeam;
  Division?: Division;
  ExploreDevelop?: ExploreDevelop;
  Function?: Function;
  OperatingUnit?: OperatingUnit;
  ProjectStatus?: ProjectStatus;
  ProjectSubType?: ProjectSubType;
  ProjectType?: ProjectType;
  Scenario?: Scenario;
  Schedule?: Schedule;
  CapitalOperationalExpenditure?: CapitalOperationalExpenditure;
  Employee?: Employee;
  Area?: Area;

  constructor(item?: IProject) {
    if (item) {

      this.ProjectId = item.ProjectId;
      this.AfeNumber = item.AfeNumber;
      this.AssetTeamId = item.AssetTeamId;
      this.IsBudgeted = item.IsBudgeted;
      this.BudgetYear = item.BudgetYear;
      this.CapitalOperationalExpendatureId = item.CapitalOperationalExpendatureId;
      this.ConstructionTypeId = item.ConstructionTypeId;
      this.TeamDevelopmentAreaId = item.TeamDevelopmentAreaId;
      this.DivisionId = item.DivisionId;
      this.ExploreDevelopId = item.ExploreDevelopId;
      this.FunctionId = item.FunctionId;
      this.NeedByDate = item.NeedByDate ? new Date(item.NeedByDate) : null;
      this.IsNeedByDateSync = item.IsNeedByDateSync;
      this.IsNeedByDateOverride = item.IsNeedByDateOverride;
      this.IsNonOperating = item.IsNonOperating;
      this.BusinessAssociateId = item.BusinessAssociateId;
      this.ProjectDescription = item.ProjectDescription;
      this.Name = item.Name;
      this.ProjectStatusId = item.ProjectStatusId;
      this.ProjectTeamId = item.ProjectTeamId;
      this.IsProjectTeamSync = item.IsProjectTeamSync;
      this.ProjectTypeId = item.ProjectTypeId;
      this.IsResearchAndDevelopmentTaxIdentifier = item.IsResearchAndDevelopmentTaxIdentifier;
      this.IsEsg = item.IsEsg;
      this.EsgAmount = item.EsgAmount;
      this.EsgCategoryId = item.EsgCategoryId;
      this.EsgJustification = item.EsgJustification;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.DefaultStandardConfigurationId = item.DefaultStandardConfigurationId;
      this.IsStandardConfigurationSync = item.IsStandardConfigurationSync;
      this.WorkingInterest = item.WorkingInterest;
      this.IsScheduleSync = item.IsScheduleSync;
      this.IsResearchAndDevelopmentBookIdentifier = item.IsResearchAndDevelopmentBookIdentifier;
      this.ResearchAndDevelopmentTaxJustification = item.ResearchAndDevelopmentTaxJustification;
      this.ResearchAndDevelopmentBookJustification = item.ResearchAndDevelopmentBookJustification;
      this.AfeApprovalDate = item.AfeApprovalDate ? new Date(item.AfeApprovalDate) : null;
      this.IsExcludedFromAnnualBudget = item.IsExcludedFromAnnualBudget;
      this.DefaultProjectTeamId = item.DefaultProjectTeamId;
      this.PDFUrl = item.PDFUrl;
      this.CreatePDF = item.CreatePDF;
      this.ScheduleId = item.ScheduleId;
      this.ScenarioId = item.ScenarioId;
      this.PMDBProjectId = item.PMDBProjectId;
      this.P6ProjectObjectId = item.P6ProjectObjectId;
      this.CreatorUserId = item.CreatorUserId;
      this.Comments = item.Comments;
      this.IsPlanningAFE = item.IsPlanningAFE;
      this.ExpansionCount = item.ExpansionCount;
      this.ProjectSubTypeId = item.ProjectSubTypeId;
      this.Prospect = item.Prospect;
      this.OperatingUnitId = item.OperatingUnitId;
      this.EPSP6ObjectId = item.EPSP6ObjectId;
      this.P6EPSObjectId = item.P6EPSObjectId;
      this.Location = item.Location;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.P6SummaryActualFinishDate = item.P6SummaryActualFinishDate ? new Date(item.P6SummaryActualFinishDate) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.P6ProjectId = item.P6ProjectId;
      this.ProjectEconomics = item.ProjectEconomics;
      this.BudgetCategoryId = item.BudgetCategoryId;
      this.AfeApprovalTeam = item.AfeApprovalTeam;
      this.BatteryDesignTypeId = item.BatteryDesignTypeId;

      this.ProjectAssetMappings_Project = Helpers.createClassArray(ProjectAssetMapping, item.ProjectAssetMappings_Project);
      this.ProjectCashCurves_Project = Helpers.createClassArray(ProjectCashCurve, item.ProjectCashCurves_Project);
      this.ProjectCompletionsParameters_Project = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_Project);
      this.ProjectCostCenters_Project = Helpers.createClassArray(ProjectCostCenter, item.ProjectCostCenters_Project);
      this.ProjectCostCodeCostTypeItems_Project = Helpers.createClassArray(ProjectCostCodeCostTypeItem, item.ProjectCostCodeCostTypeItems_Project);
      this.ProjectCostCodeCostTypeItemsRevisions_Project = Helpers.createClassArray(ProjectCostCodeCostTypeItemsRevision, item.ProjectCostCodeCostTypeItemsRevisions_Project);
      this.ProjectDrillingParameters_Project = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_Project);
      this.ProjectEstimateAtCompletions_Project = Helpers.createClassArray(ProjectEstimateAtCompletion, item.ProjectEstimateAtCompletions_Project);
      this.ProjectEstimates_Project = Helpers.createClassArray(ProjectEstimate, item.ProjectEstimates_Project);
      this.ProjectItemCapacityOverrides_Project = Helpers.createClassArray(ProjectItemCapacityOverride, item.ProjectItemCapacityOverrides_Project);
      this.ProjectModuleGasLiftLines_Project = Helpers.createClassArray(ProjectModuleGasLiftLine, item.ProjectModuleGasLiftLines_Project);
      this.ProjectModulePipelines_Project = Helpers.createClassArray(ProjectModulePipeline, item.ProjectModulePipelines_Project);
      this.ProjectModuleWellConnectSurfaceEquipments_Project = Helpers.createClassArray(ProjectModuleWellConnectSurfaceEquipment, item.ProjectModuleWellConnectSurfaceEquipments_Project);
      this.ProjectPondParameters_Project = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_Project);
      this.ProjectResourceCalculationsAssignments_Project = Helpers.createClassArray(ProjectResourceCalculationsAssignment, item.ProjectResourceCalculationsAssignments_Project);
      this.ProjectResourceItems_Project = Helpers.createClassArray(ProjectResourceItem, item.ProjectResourceItems_Project);
      this.ProjectResourceItemsRevisions_Project = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_Project);
      //this.ProjectTeamMemberAssignments_Project = Helpers.createClassArray(ProjectTeamMemberAssignment, item.ProjectTeamMemberAssignments_Project);
      this.ResourceAssignments_Project = Helpers.createClassArray(ResourceAssignment, item.ResourceAssignments_Project);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.BudgetCategory = new BudgetCategory(item.BudgetCategory);
      this.BusinessAssociate = new BusinessAssociate(item.BusinessAssociate);
      this.ConstructionType = new ConstructionType(item.ConstructionType);
      this.DefaultProjectTeam = new DefaultProjectTeam(item.DefaultProjectTeam);
      this.Division = new Division(item.Division);
      this.ExploreDevelop = new ExploreDevelop(item.ExploreDevelop);
      this.Function = new Function(item.Function);
      this.OperatingUnit = new OperatingUnit(item.OperatingUnit);
      this.ProjectStatus = new ProjectStatus(item.ProjectStatus);
      this.ProjectSubType = new ProjectSubType(item.ProjectSubType);
      this.ProjectType = new ProjectType(item.ProjectType);
      this.Scenario = new Scenario(item.Scenario);
      this.Schedule = new Schedule(item.Schedule);
      this.CapitalOperationalExpenditure = new CapitalOperationalExpenditure(item.CapitalOperationalExpenditure);
      this.Employee = new Employee(item.Employee);
      this.Area = new Area(item.Area);
    }
  }
}